import Model from '../Model';
import Mithril from 'mithril';
import HeroTagHeroIntro from './HeroTagHeroIntro';


export default class HeroTagLatestdata extends Model {
  tagId() {
    return Model.attribute<number>('tagId').call(this);
  }
  mainImage() {
    return Model.attribute<string>('mainImage').call(this);
  }
  mainTitle() {
    return Model.attribute<string>('mainTitle').call(this);
  }
  storyImg() {
    return Model.attribute<string>('storyImg').call(this);
  }
  storyContent() {
    return Model.attribute<string>('storyContent').call(this);
  }
  heroTagHeroIntro() {
    return Model.hasMany<HeroTagHeroIntro>('heroTagHeroIntro').call(this);
  }

}
